import { API_BASE_URL } from '@/shared/constants/config';

export const fmoInputService = {
  /**
   * Fetch all entries (paginated)
   */
  async fetchAll(params = {}) {
    const {
      offset = 0,
      limit = 1000,
      orderBy = '-created_at'
    } = params;

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
      order_by: orderBy
    });

    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE_URL}/entries?${queryParams}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch FMO inputs: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  },

  /**
   * Fetch entries by IDs
   */
  async fetchByIds(entryIds) {
    if (!entryIds || entryIds.length === 0) {
      return { items: [], count: 0, total: 0 };
    }

    const token = localStorage.getItem('access_token');
    
    // Build query with multiple id filters
    const queryParams = new URLSearchParams();
    entryIds.forEach(id => queryParams.append('ids', id));
    queryParams.append('limit', '1000');

    const response = await fetch(`${API_BASE_URL}/entries?${queryParams}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch FMO inputs: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Get single entry details
   */
  async getById(entryId) {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE_URL}/entries/${entryId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch entry: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Get complex PDB file for 3D visualization
   */
  async getComplexPDB(entryId) {
    const entry = await this.getById(entryId);
    
    if (!entry.complex_ || !entry.complex_.filepath) {
      throw new Error('No complex file available for this entry');
    }

    // Fetch the complex PDB file content
    const token = localStorage.getItem('access_token');
    const complexId = entry.complex_.id_;
    
    const response = await fetch(`${API_BASE_URL}/complexes/${complexId}/download`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch complex PDB: ${response.statusText}`);
    }

    return response.text();
  }
};